import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect } from 'react';
import ModalContext from '~/context/srp/ModalContext';
import { NativeModalId } from '~/context/srp/ModalContext/constants';
import sendMessageToNative from './sendMessageToNative';

function sendMessageToOpenNativeModal(
  modal: NativeModalId,
  onError: () => void
) {
  sendMessageToNative(DispatcherEvent.OpenModal, { modal }, { onError });
}

export default function useModalMessageDispatcher() {
  const {
    isGeolocationModalOpen,
    isSoftPullModalOpen,
    setGeolocationModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);

  useEffect(() => {
    if (isGeolocationModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.Geolocation, () =>
        setGeolocationModalOpen(false)
      );
    }

    if (isSoftPullModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () =>
        setSoftPullModalOpen(false)
      );
    }
  }, [
    isGeolocationModalOpen,
    isSoftPullModalOpen,
    setGeolocationModalOpen,
    setSoftPullModalOpen
  ]);
}
